import { z } from 'zod';
import { DepartmentSchema } from './department';

export const ChecklistItemSchema = z.object({
  name: z.string(),
  isRequired: z.boolean(),
  value: z.boolean().optional(),
});

export const ChecklistAttributeSchema = z.object({
  field: z.literal('checklist'),
  value: z.array(ChecklistItemSchema),
});

export const AllAttributesTypesSchema = z.discriminatedUnion('field', [ChecklistAttributeSchema]);

export const fieldValuesSchema = z.object({
  id: z.string().uuid(),
  isCompleted: z.boolean(),
  completedDateTime: z.string().nullable(),
  values: z.array(AllAttributesTypesSchema).nullable(),
  completedBy: z
    .object({
      fullName: z.string(),
      id: z.string().uuid(),
    })
    .nullable(),
});

export const StageSchema = z.object({
  name: z.string(),
  ordinal: z.number(),
  completionRules: z.string(),
  fieldValues: fieldValuesSchema,
  businessProcessFlowId: z.string().uuid(),
  businessProcessFlowStageId: z.string().uuid(),
  stageFields: z.array(AllAttributesTypesSchema),
});

export const CreateOrUpdateStageSchema = z.object({
  name: z.string(),
  ordinal: z.number(),
  completionRules: z.any(),
  id: z.string().uuid().nullable().optional(),
  stageFields: z.array(AllAttributesTypesSchema),
});

export const BPFApplyRulesSchema = z.object({
  paymentType: z.string(),
});

export const TemplateSchema = z.object({
  name: z.string(),
  isActive: z.boolean(),
  createdBy: z.string(),
  createdDateTime: z.string(),
  accountId: z.string().uuid(),
  stages: z.array(StageSchema),
  department: DepartmentSchema,
  applyRules: BPFApplyRulesSchema,
  modifiedDateTime: z.boolean().nullable(),
  businessProcessFlowId: z.string().uuid(),
});

export const CreateBPFTemplateSchema = z.object({
  isActive: z.boolean(),
  accountId: z.string().uuid(),
  departmentId: z.string().uuid(),
  applyRules: BPFApplyRulesSchema,
  name: z.string().min(1),
  stages: z.array(CreateOrUpdateStageSchema),
});

export const UpdateBPFTemplateSchema = z
  .object({
    businessProcessFlowId: z.string().uuid(),
  })
  .and(CreateBPFTemplateSchema);

export const UpdateStageFieldsSchema = z.object({
  parentId: z.string().uuid(),
  parentType: z.string(),
  stageId: z.string().uuid(),
  stageFields: z.array(AllAttributesTypesSchema),
});
